import type { ChatMessageView } from "web_myplann/Chat/Types/chatMessage";
import { isImageMimeType } from "web_myplann/Shared/Utils/isImageMimeType";

type Args = {
	clientId: string;
	content: string;
	file?: File;
	localAttachmentUrl?: string;
};

let nextSequence = 1;

export const createOptimisticChatMessage = ({
	clientId,
	content,
	file,
	localAttachmentUrl,
}: Args): ChatMessageView => ({
	id: 0,
	clientId,
	content,
	direction: "sender",
	isRead: false,
	createdAt: new Date(),
	fromName: "",
	status: "pending",
	sequence: nextSequence++,
	attachments: file
		? [
				{
					type: isImageMimeType(file.type) ? "image" : "file",
					mimeType: file.type,
					fileName: file.name,
					isImage: isImageMimeType(file.type),
					localUrl: localAttachmentUrl,
				},
			]
		: [],
});
